import { AiseaApiFactory } from "@/api/aisea/apiFactory";

const enterpriseCrewSchedulerRepository = AiseaApiFactory.get(
  "enterpriseCrewScheduler"
);

const EnterpriseCrewSchedulerService = (() => {
  let _enterpriseCrewScheduler = null;

  const fetch = async () => {
    const res = await enterpriseCrewSchedulerRepository.get();
    if (!res || !res.status) {
      throw res;
    }
    _enterpriseCrewScheduler = res.data;
    return _enterpriseCrewScheduler;
  };

  return {
    fetch
  };
})();

export default EnterpriseCrewSchedulerService;
